const InitialState: any = {
  id: 0,
  
  equipmentType: 1,
  listing_name: "",
  listing_description: "",
  manufacturer_id: undefined,
  manufacturer_model_id: undefined,
  attachment_id: undefined,
  attachment_type: "",

  price: undefined,
  price_unit: undefined,
  horse_power: undefined,
  year: undefined,
  emv: undefined,

  capacity: undefined,
  capacity_unit: "feets",

  has_loader_bucker: false,
  has_3point_lift: false,
  has_pto: false,
  has_cabin: false,
  has_ac: false,
  has_heater: false,
  has_4wd: false,
  has_power_steering: false,

  images: [],

  usage_type: 1,
  custom_hours: undefined,
  custom_excess_hours_fee: undefined,
  custom_min_rental_duration: undefined,

  custom_hours_unit: "",
  custom_excess_hours_fee_unit: "",
};
export default InitialState
